import qs from 'querystring'
import Api from '../lib/request'
import COOKIECONSTANT from '../constant/cookie'
import cookie from '../lib/cookie'
import _ from 'underscore'
import STATUS_CODE from '../constant/status_code'

const emptyOrderListData = {
  page:{
    pageNum: 0,
    total: 0,
  },
  list: [],
}

const EMPTY_LIST_DATA = {
  page: {
    pageNum: 0,
    total: 0,
  },
  list: [],
}
const getExamineOrderList = (queryData) => {
  return new Promise((resolve, reject) => {
    let query = ''
    if(!_.isEmpty(queryData)) {
      query = `?${qs.stringify(queryData)}`
    }
    let url = COOKIECONSTANT.REQUEST_HOST+`${query}`
    // url = 'http://easymock.sdyxmall.cn/mock/5ba05c13292c034d86d87b50/mall/api/order/list'
    Api.get(url, {
        headers: {
          'X-Host': 'mall.examine.examine-order.list',
          'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN) || ''
        },
      })
      .then((data) => {
        if(data.status == 6003) {
          return resolve(emptyOrderListData)
        }
        if(data.status != 0) {
          return reject(data.msg)
        }
        resolve(data.data)
      }, (e) => {
        reject(e)
      })
  })
}
const getAgencyList = (queryData) => {
  return new Promise((resolve, reject) => {
    let query = ''
    if(!_.isEmpty(queryData)) {
      query = `?${qs.stringify(queryData)}`
    }
    let url = COOKIECONSTANT.REQUEST_HOST+`${query}`
    Api.get(url, {
        headers: {
          'X-Host': 'mall.examine.examine-agency.list',
          'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN) || ''
        },
      })
      .then((data) => {
        if(data.status != 0) {
          return reject(data.msg)
        }
        resolve(data.data)
      }, (e) => {
        reject(e)
      })
  })
}
const getScheduleList = (queryData) => {
  return new Promise((resolve, reject) => {
    let query = ''
    if(!_.isEmpty(queryData)) {
      query = `?${qs.stringify(queryData)}`
    }
    let url = COOKIECONSTANT.REQUEST_HOST+`${query}`
    // url = 'http://easymock.sdyxmall.cn/mock/5ba05c13292c034d86d87b50/mall/api/agency/schedule-list'
    Api.get(url, {
        headers: {
          'X-Host': 'mall.examine.examine-agency.schedule-list',
          'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN) || ''
        },
      })
      .then((data) => {
        if(data.status != 0) {
          return reject(data.msg)
        }
        resolve(data.data)
      }, (e) => {
        reject(e)
      })
  })
}
const getExamineReserveList = (queryData) => {
  return new Promise((resolve, reject) => {
    let query = ''
    if(!_.isEmpty(queryData)) {
      query = `?${qs.stringify(queryData)}`
    }
    let url = COOKIECONSTANT.REQUEST_HOST+`${query}`
    // url = 'http://easymock.sdyxmall.cn/mock/5ba05c13292c034d86d87b50/mall/api/examine-order/list-by-order-id'
    Api.get(url, {
        headers: {
          'X-Host': 'mall.examine.examine-order.list-by-order-id',
          'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN) || ''
        },
      })
      .then((data) => {
        if(data.status != 0) {
          let err = new Error(data.msg)
          err.code = data.status
          return reject(err)
        }
        resolve(data.data)
      }, (e) => {
        reject(e)
      })
  })
}
// 预约详情
const getExamineReserveDetail = (queryData) => {
  return new Promise((resolve, reject) => {
    let query = ''
    if(!_.isEmpty(queryData)) {
      query = `?${qs.stringify(queryData)}`
    }
    let url = COOKIECONSTANT.REQUEST_HOST+`${query}`
    // url = 'http://easymock.sdyxmall.cn/mock/5ba05c13292c034d86d87b50/mall/api/examine-order/info'
    Api.get(url, {
        headers: {
          'X-Host': 'mall.examine.examine-order.info',
          'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN) || ''
        },
      })
      .then((data) => {
        if(data.status != 0) {
          return reject(data.msg)
        }
        resolve(data.data)
      }, (e) => {
        reject(e)
      })
  })
}
// 预约
const createExamineReserve = (queryData) => {
  return new Promise((resolve, reject) => {
    let url = COOKIECONSTANT.REQUEST_HOST
    // url = 'http://easymock.sdyxmall.cn/mock/5ba05c13292c034d86d87b50/mall/api/common/callback'
    Api.post(url, JSON.stringify(queryData), {
        headers: {
          'X-Host': 'mall.examine.examine-order.create',
          'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN) || ''
        },
      })
      .then((data) => {
        if(data.status != 0) {
          let err = new Error(data.msg)
          err.code = data.status
          return reject(err)
        }
        resolve(data.data)
      }, (e) => {
        reject(e)
      })
  })
}
// 修改预约
const updateExamineReserve = (queryData) => {
  return new Promise((resolve, reject) => {
    let url = COOKIECONSTANT.REQUEST_HOST
    // url = 'http://easymock.sdyxmall.cn/mock/5ba05c13292c034d86d87b50/mall/api/common/callback'
    Api.post(url, JSON.stringify(queryData), {
        headers: {
          'X-Host': 'mall.examine.examine-order.edit',
          'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN) || ''
        },
      })
      .then((data) => {
        if(data.status != 0) {
          let err = new Error(data.msg)
          err.code = data.status
          return reject(err)
        }
        resolve(data.data)
      }, (e) => {
        reject(e)
      })
  })
}
// 取消
const cancelExamineReserve = (queryData) => {
  return new Promise((resolve, reject) => {
    let url = COOKIECONSTANT.REQUEST_HOST
    Api.post(url, JSON.stringify(queryData), {
        headers: {
          'X-Host': 'mall.examine.examine-order.cancel',
          'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN) || ''
        },
      })
      .then((data) => {
        if(data.status != 0) {
          let err = new Error(data.msg)
          err.code = data.status
          return reject(err)
        }
        resolve(data.data)
      }, (e) => {
        reject(e)
      })
  })
}

const getAgencyDetail = (queryData) => {
  return new Promise((resolve, reject) => {
    let query = ''
    if (!_.isEmpty(queryData)) {
      query = `?${qs.stringify(queryData)}`
    }
    let url = COOKIECONSTANT.REQUEST_HOST + `${query}`
    Api.get(url, {
      headers: {
        'X-Host': 'mall.examine.examine-agency.info',
        'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN) || ''
      },
    })
      .then((data) => {
        if (data.status != 0) {
          return reject(data.msg)
        }
        resolve(data.data)
      }, (e) => {
        reject(e)
      })
  })
}

const getPackagesListOfAgency = (queryData) => {
  return new Promise((resolve, reject) => {
    let query = ''
    if (!_.isEmpty(queryData)) {
      query = `?${qs.stringify(queryData)}`
    }
    let url = COOKIECONSTANT.REQUEST_HOST + `${query}`
    Api.get(url, {
      headers: {
        'X-Host': 'mall.examine.examine-package.list',
        'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN) || ''
      },
    })
      .then((data) => {
        if (data.status == 6003) {
          return resolve(EMPTY_LIST_DATA)
        }
        if (data.status != 0) {
          return reject(data.msg)
        }
        resolve(data.data)
      }, (e) => {
        reject(e)
      })
  })
}
const getExamineBanner = () => {
  return new Promise((resolve, reject) => {
    let url = COOKIECONSTANT.REQUEST_HOST + `?type=35`

    Api.get(url, {
      headers: {
        'X-Host': 'mall.cfg.common-banner',
        'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN)
      }
    }).then(data => {
      if(data.status !== 0) {
        return reject(data.msg)
      }
      resolve(data.data)
    }, e => {
      reject(e)
    })
  })
}
const getExamineSubBanner = () => {
  return new Promise((resolve, reject) => {
    let url = COOKIECONSTANT.REQUEST_HOST + `?type=36`

    Api.get(url, {
      headers: {
        'X-Host': 'mall.cfg.common-banner',
        'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN)
      }
    }).then(data => {
      if(data.status !== 0) {
        return reject(data.msg)
      }
      resolve(data.data)
    }, e => {
      reject(e)
    })
  })
}
// v1.6.5 版本 根据筛选项获取机构列表
const filterAgencyList = (queryData) => {
  return new Promise((resolve, reject) => {
    let url = COOKIECONSTANT.REQUEST_HOST
    // url = 'http://easymock.sdyxmall.cn/mock/5ba05c13292c034d86d87b50/mall/api/examine-channel/agency-list'
    Api.post(url, JSON.stringify(queryData), {
        headers: {
          'X-Host': 'mall.examine.agency.list-by-cityId',
          'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN) || ''
        },
      })
      .then((data) => {
        if(data.status == 6003) {
          return resolve(emptyOrderListData)
        }
        if(data.status != 0) {
          return reject(data.msg)
        }
        resolve(data.data)
      }, (e) => {
        reject(e)
      })
  })
}

const addExaminer = (queryData) => {
  return new Promise((resolve, reject) => {
    let url = COOKIECONSTANT.REQUEST_HOST
    Api.post(url, JSON.stringify(queryData), {
      headers: {
        'X-Host': 'mall.examine.examiner.add-info',
        'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN) || ''
      },
    })
      .then((data) => {
        if (data.status != 0) {
          let err = new Error(data.msg)
          err.code = data.status
          return reject(err)
        }
        resolve(data.data)
      }, (e) => {
        reject(e)
      })
  })
}

// v1.6.5 版本 根据筛选项获取套餐列表
const filterPackageList = (queryData) => {
  return new Promise((resolve, reject) => {
    let url = COOKIECONSTANT.REQUEST_HOST
    // url = 'http://easymock.sdyxmall.cn/mock/5ba05c13292c034d86d87b50/mall/api/examine-channel/pack'
    Api.post(url, JSON.stringify(queryData), {
        headers: {
          'X-Host': 'mall.examine.package.list-by-cityId',
          'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN) || ''
        },
      })
      .then((data) => {
        if(data.status == 6003) {
          return resolve(emptyOrderListData)
        }
        if(data.status != 0) {
          return reject(data.msg)
        }
        resolve(data.data)
      }, (e) => {
        reject(e)
      })
  })
}
const editExaminer = (queryData) => {
  return new Promise((resolve, reject) => {
    let url = COOKIECONSTANT.REQUEST_HOST
    Api.post(url, JSON.stringify(queryData), {
      headers: {
        'X-Host': 'mall.examine.examiner.update-info',
        'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN) || ''
      },
    })
      .then((data) => {
        if (data.status != 0) {
          let err = new Error(data.msg)
          err.code = data.status
          return reject(err)
        }
        resolve(data.data)
      }, (e) => {
        reject(e)
      })
  })
}

// v1.6.5 版本 机构筛选器
const getAgencySelector = (queryData) => {
  return new Promise((resolve, reject) => {
    let url = COOKIECONSTANT.REQUEST_HOST
    // url = 'http://easymock.sdyxmall.cn/mock/5ba05c13292c034d86d87b50/mall/api/examine-channel/agency-selector'
    Api.post(url, JSON.stringify(queryData), {
        headers: {
          'X-Host': 'mall.examine.agency.selector',
          'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN) || ''
        },
      })
      .then((data) => {
        if(data.status != 0) {
          return reject(data.msg)
        }
        resolve(data.data)
      }, (e) => {
        reject(e)
      })
  })
}
const getExaminerList = () => {
  const queryData = {
    pageNum: 1,
    pageSize: 100,
  }
  return new Promise((resolve, reject) => {
    let query = ''
    if (!_.isEmpty(queryData)) {
      query = `?${qs.stringify(queryData)}`
    }
    let url = COOKIECONSTANT.REQUEST_HOST + `${query}`
    Api.get(url, {
      headers: {
        'X-Host': 'mall.examine.examiner.info-list',
        'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN) || ''
      },
    })
      .then((data) => {
        if (data.status == 6003) {
          return resolve(EMPTY_LIST_DATA)
        }
        if (data.status != 0) {
          return reject(data.msg)
        }
        resolve(data.data)
      }, (e) => {
        reject(e)
      })
  })
}
// v1.6.5 版本 套餐筛选器
const getPackageSelector = (queryData) => {
  return new Promise((resolve, reject) => {
    let url = COOKIECONSTANT.REQUEST_HOST
    // url = 'http://easymock.sdyxmall.cn/mock/5ba05c13292c034d86d87b50/mall/api/examine-channel/package-selector'
    Api.post(url, '', {
        headers: {
          'X-Host': 'mall.examine.package.selector',
          'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN) || ''
        },
      })
      .then((data) => {
        if(data.status != 0) {
          return reject(data.msg)
        }
        resolve(data.data)
      }, (e) => {
        reject(e)
      })
  })
}

const getExaminerDetail = (queryData) => {

  return new Promise((resolve, reject) => {
    let query = ''
    if (!_.isEmpty(queryData)) {
      query = `?${qs.stringify(queryData)}`
    }
    let url = COOKIECONSTANT.REQUEST_HOST + `${query}`
    Api.get(url, {
      headers: {
        'X-Host': 'mall.examine.examiner.info-by-id',
        'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN) || ''
      },
    })
      .then((data) => {
        if (data.status != 0) {
          return reject(data.msg)
        }
        resolve(data.data)
      }, (e) => {
        reject(e)
      })
  })
}
const deleteExamineOrder = (queryData) => {
  return new Promise((resolve, reject) => {
    let url = COOKIECONSTANT.REQUEST_HOST
    Api.post(url, JSON.stringify(queryData), {
      headers: {
        'X-Host': 'mall.examine.order.del',
        'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN) || ''
      }
    }).then(data => {
      if(data.status !== 0) {
        return reject(data.msg)
      }
      return resolve(data.data)
    }, e => {
      reject(e)
    })
  })
}
export default {
  getExamineOrderList,
  getAgencyList,
  getScheduleList,
  getExamineReserveList,
  getExamineReserveDetail,
  createExamineReserve,
  updateExamineReserve,
  cancelExamineReserve,
  getAgencyDetail,
  getPackagesListOfAgency,
  getExamineBanner,
  getExamineSubBanner,
  filterAgencyList,
  filterPackageList,
  getAgencySelector,
  getPackageSelector,
  addExaminer,
  getExaminerList,
  editExaminer,
  getExaminerDetail,
  deleteExamineOrder,
}
